import { createBrowserRouter, createRoutesFromElements, Route, RouterProvider } from 'react-router-dom';
import createStore from 'react-auth-kit/createStore';
import AuthProvider from 'react-auth-kit';
import { QueryClient, QueryClientProvider } from 'react-query';
import MainLayout from './components/MainLayout';
import { AppProvider } from './context/AppContext';
import Login from 'pages/Auth/Login';
import Dashboard from 'pages/Dashboard';
import { ConfigProvider } from 'antd';
import NotFound from 'pages/NotFound';
import OrderRoute from 'routes/order';
import Logout from 'pages/Auth/Logout';
import ProductRoute from 'routes/product';
import UserRoute from 'routes/user';
import StaffRoute from 'routes/staff';
import CategoryRoute from 'routes/category';
import BannerRoute from 'routes/banner';
import SettingRoute from 'routes/setting';
import SatuanRoute from 'routes/satuan';
import ReportRoute from 'routes/report';
import VoucherRoute from 'routes/voucher';
import OrderQueueDisplay from 'pages/OrderQueueDisplay';
import PurchaseRoute from 'routes/purchase';
import SellingRoute from 'routes/selling';
import CashierRoute from 'routes/cashier';
import OrderInvoiceView from 'pages/OrderInvoiceView';
import CashflowRoute from 'routes/cashflow';
import AttendanceRoute from 'routes/attendance';
import AffiliatorRoute from 'routes/affiliator';
import DiscountRoute from 'routes/discount';


const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

const authStore = createStore({
  authType: "cookie",
  authName: process.env.REACT_APP_SESSION_PREFIX,
  cookieDomain: window.location.hostname, // atau bisa diatur menjadi "localhost" saat di local development
  debug: process.env.NODE_ENV !== "production",
  cookieSecure: process.env.NODE_ENV === "production", // `false` untuk lokal, `true` untuk produksi
});

function App() {
  const router = createBrowserRouter(
    createRoutesFromElements(
      <>
        <Route path="/" element={<MainLayout />}>
          <Route path="/" element={<Dashboard />} />

          <Route path="/users/*" element={<UserRoute />} />
          <Route path="/staff/*" element={<StaffRoute />} />
          <Route path="/orders/*" element={<OrderRoute />} />
          <Route path="/products/*" element={<ProductRoute />} />
          <Route path="/categories/*" element={<CategoryRoute />} />
          <Route path="/banners/*" element={<BannerRoute />} />
          <Route path="/discounts/*" element={<DiscountRoute />} />
          <Route path="/settings/*" element={<SettingRoute />} />
          <Route path="/satuan/*" element={<SatuanRoute />} />
          <Route path="/reports/*" element={<ReportRoute />} />
          <Route path="/vouchers/*" element={<VoucherRoute />} />
          <Route path="/purchase/*" element={<PurchaseRoute />} />
          <Route path="/selling/*" element={<SellingRoute />} />
          <Route path="/cashier/*" element={<CashierRoute />} />
          <Route path="/cashflow/*" element={<CashflowRoute />} />
          <Route path="/attendance/*" element={<AttendanceRoute />} />
          <Route path="/affiliators/*" element={<AffiliatorRoute />} />

          <Route path="/logout" element={<Logout />} />
          <Route path="*" element={<NotFound />} />
        </Route>

        <Route path="/orders/queue/display" element={<OrderQueueDisplay />} />

        <Route path="/orders/invoice/:order_id" element={<OrderInvoiceView />} />

        <Route path="/login" element={<Login />} />
      </>
    )
  );

  return (
    <QueryClientProvider client={queryClient}>
      <ConfigProvider theme={{ token: { colorPrimary: '#09a603' } }}>
        <AuthProvider store={authStore}>
          <AppProvider>
            <RouterProvider router={router} />
          </AppProvider>
        </AuthProvider>
      </ConfigProvider>
    </QueryClientProvider>
  );

}

export default App;
